import intendedScrollTo from './intended-scroll-to.js';
import smoothScroll from './smooth-scroll.js';

export default function (percentage) {
  return (dispatch) => {
    dispatch(intendedScrollTo(percentage));
    dispatch(smoothScroll());
  };
}
